import { useEffect, useState } from 'react'
import UserInfoService, { GetUserInfoResponse } from '../../../../services/UserService'
import * as Sentry from '@sentry/react'
import { notification } from 'antd'
import { ProposalViewTabEnum } from './proposal-view.types'
import { useProposalViewTabs } from './hooks/use-proposal-view-tabs'

type ReturnType = {
  isLoading: boolean;
  shouldShowMainLayout: boolean;
  shouldShowCatalogSearch: boolean;
  shouldShowHandleInput: boolean;
  shouldShowExternalSource: boolean;
  activeTab: ProposalViewTabEnum;
  onChangeActiveTab: (tabKey: string) => void;
}

export function useProposalView(): ReturnType {
  const [isLoading, setLoading] = useState<boolean>(true)
  const [shouldShowMainLayout, setShowMainLayout] = useState<boolean>(false)
  const [shouldShowCatalogSearch, setShowCatalogSearch] = useState<boolean>(false)
  const [shouldShowHandleInput, setShowHandleInput] = useState<boolean>(false)
  const [shouldShowExternalSource, setShowExternalSource] = useState<boolean>(false)
  const [{ activeTab }, { onChangeActiveTab }] = useProposalViewTabs()

  useEffect(() => {
    let isMounted = true

    UserInfoService
      .getUserInfo()
      .then(({ company_id: companyId }: GetUserInfoResponse) => {
        if (!isMounted) {
          return
        }
        setShowMainLayout(!!companyId)
        setShowCatalogSearch(companyId != '16832465')
        setShowHandleInput(companyId != '16832465')
        setShowExternalSource(true)

        if (!shouldShowCatalogSearch) {
          onChangeActiveTab(ProposalViewTabEnum.ExternalSource)
        }
      })
      .catch((error: Error) => {
        if (!isMounted) {
          return
        }
        setShowMainLayout(false)
        notification.error({
          message: 'Ошибка при получении данных пользователя',
          description: error.message,
          duration: 5,
        })
        Sentry.captureException(error)
      })
      .finally(() => {
        if (!isMounted) {
          return
        }
        setLoading(false)
      })

    return () => {
      isMounted = false
    }
  }, [])

  return {
    isLoading,
    shouldShowMainLayout,
    shouldShowCatalogSearch,
    shouldShowHandleInput,
    shouldShowExternalSource,
    activeTab,
    onChangeActiveTab,
  }
}
